export const MCP_CONNECT_ROUTE = { name: 'McpConnect' } as const
/**
 * Redirect-only since ORP-27468: the in-app connections screen moved to mcp.orphex.co, and this
 * name now just sends an old `/settings/mcp/connections` link home. Never link to it — open the
 * shell through `@/features/auth`'s `openOrphexMcp` instead.
 */
export const MCP_CONNECTIONS_ROUTE = { name: 'McpConnections' } as const

/**
 * The MCP shell's consent entry (`mcp_orphex_front`), on its own origin — hence a bare URL rather
 * than a route target. Three callers: the ORP-21843 cut-over redirect that forwards a stale
 * `/settings/mcp/connect` link here verbatim, the ORP-21836 enable card, for which this flow IS
 * the "enable" path (signup/connect provisioning attaches the `mcp_free` addon to an existing web
 * account, `interaction_gateway/application/signup_provisioning.py`), and the assistant catalog's
 * "Setup guide" link (ORP-21856) — which pointed at the redirect's stale input until it read from
 * here.
 */
export const MCP_SHELL_CONNECT_URL = 'https://mcp.orphex.co/connect'

export { MCP_SHELL_LOGIN_URL, MCP_SHELL_SIGNUP_URL } from '@/shared/lib/mcpShell'
